export default "__VITE_ASSET__CickD3Dq__"